import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const FifteenSecBackButton = styled.button`
    background: none;
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    margin-right: 30px;
    position: relative;

    p {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -59%);
        font-family: inherit;
        font-size: 12px;
        font-weight: 500;
        color: ${p => p.theme.playerIconsColor};
    }

    ${cssMediaQueryBreakpoints.medium} {
        margin-right: 24px;
    }
`
